export function fullHeightTestimonials() {
    const $slider = $(".full-height-testimonials");
    $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        fade: true,
        infinite: false,
        prevArrow: "<button class=\"slide-arrow slick-prev\"><svg width=\"13\" height=\"10\" viewBox=\"0 0 13 10\">\n" +
            "<path d=\"M5.76256 9.95006L6.38128 9.33134L2.48645 5.43651L12.751 5.43651L12.751 4.56412L2.48645 4.56412L6.38128 0.669287L5.76256 0.0505685L0.812815 5.00032L5.76256 9.95006Z\" fill=\"#111111\"/>\n" +
            "</svg></button>",
        nextArrow: "<button class=\"slide-arrow slick-next\"><svg width=\"13\" height=\"10\" viewBox=\"0 0 13 10\">\n" +
            "<path d=\"M7.23744 9.95006L6.61872 9.33134L10.5136 5.43651L0.249013 5.43651L0.249013 4.56412L10.5136 4.56412L6.61872 0.669287L7.23744 0.0505685L12.1872 5.00032L7.23744 9.95006Z\" fill=\"#111111\"/>\n" +
            "</svg></button>",
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/fullHeightTestimonials.js